import ValidationError from "./ValidationError.js"

export default class SubstanceValidationError extends ValidationError {
	constructor(errors) {
		super();
		this.errors = errors;
	}
}
